export const APPEARANCE_MODE_LIGHT = 'LIGHT';
export const APPEARANCE_MODE_DARK = 'DARK';

export const APPEARANCE_ENUMS = [APPEARANCE_MODE_LIGHT, APPEARANCE_MODE_DARK] as const;

export const SPACING = 4;

export const SHAPE_SQUARE = 'square';
export const SHAPE_ROUNDED = 'rounded';
export const SHAPE_CIRCULAR = 'circular';
